import { dateHelper } from "./dateHelper";

//UDA
const DAYS_DEADLINE_UDA = 3;
const DAYS_DEADLINE_REVISION_UDA = 2;
const HOUR_DEADLINE_UDA = "08:00";

export const examHelper = {
  
  canEditUDA(dateExam, examStatus, rCode, excludeFromCheck = []) {
    if (excludeFromCheck.includes(rCode)) {
      return true;
    }

    // come da accordi con Nino telefonicamente il 19/06/2025 ore 11.00 e indicato a mezzo team a francesco  le regole sono 1 e 2

    // 1. la prova si può svolgere fino a 3 giorni prima della data fissata entro le  ore 08:00
    const dayLeft = dateHelper.dayLeft(dateExam);

    if (dayLeft > DAYS_DEADLINE_UDA) {
      return true;
    } else if (dayLeft === DAYS_DEADLINE_UDA) {
      const minuteLeft = dateHelper.minuteLeft(HOUR_DEADLINE_UDA);
      if (minuteLeft > 0) {
        return true;
      }
    }

    // 2. nel caso di uda in stato di revisione essa si può modificare fino a 2 giorno prima della data fissata (entro le 8.00 del mattino)
    if (dateExam && examStatus === "revisionPending") {
      if (dayLeft > DAYS_DEADLINE_REVISION_UDA) {
        return true;
      }
    }

    return false;
  },

  canEditSubject(dateExam, daysDeadline, hourDeadline, rCode, excludeFromCheck = []) {
    if (excludeFromCheck.includes(rCode)) return true;

    if (!dateExam) return true;

    const dayLeft = dateHelper.dayLeft(dateExam);

    if (dayLeft > daysDeadline) return true;
    else if (dayLeft === daysDeadline) {
      const minuteLeft = dateHelper.minuteLeft(hourDeadline);
      return minuteLeft > 0;
    }
    return false;
  },
};
